import ReactSelect from 'react-select';
import classNames from 'classnames';

export const Select = ({
  options,
  field,
  errors,
  name,
  placeholder,
  onChange,
  value,
  className,
}) => {
  const handleChange = (option) => {
    field?.onChange(option ? option.value : '');
    onChange?.(option ? option.value : '');
  };

  return (
    <ReactSelect
      {...field}
      options={options}
      placeholder={placeholder}
      classNamePrefix='custom-select'
      className={classNames(
        'w-full',
        { 'border-red-500': errors?.[name] },
        className,
      )}
      onChange={handleChange}
      value={
        options.find((option) => option.value === (field?.value || value)) ||
        null
      }
      styles={{
        control: (base) => ({
          ...base,
          borderColor: errors?.[name] ? '#ef4444' : '#d1d5db',
          '&:hover': {
            borderColor: errors?.[name] ? '#ef4444' : '#9ca3af',
          },
          border: className?.includes('no-borders') ? 'none' : base.border,
          boxShadow: 'none',
          borderRadius: '0.5rem',
          padding: className?.includes('no-padding') ? '0' : '0 0 0 2rem',
          cursor: 'pointer',
        }),
        indicatorSeparator: (base) =>
          className?.includes('no-divider')
            ? { ...base, display: 'none' }
            : base,
        option: (base, { isFocused, isSelected }) => ({
          ...base,
          backgroundColor: isSelected
            ? '#3b82f6'
            : isFocused
            ? '#e5e7eb'
            : 'white',
          color: isSelected ? 'white' : '#111827',
          cursor: 'pointer',
        }),
        menu: (base) => ({
          ...base,
          borderRadius: '0.5rem',
          marginTop: '0.25rem',
        }),
      }}
    />
  );
};
